import {
  API_HOST,
  API_HOST_JAVA
} from './local.js'
import Qs from 'qs'
import axios from 'axios'
import Lockr from 'lockr'
// import Vueaxios from 'vue-axiosp'
const axiosPhp = axios.create({
  baseURL: API_HOST
})
// axiosPhp.defaults.baseURL = API_HOST
axiosPhp.defaults.headers['Content-Type'] = 'application/json'
axiosPhp.defaults.timeout = 1000 * 15
axiosPhp.defaults.headers.authKey = Lockr.get('authKey')
axiosPhp.defaults.headers.sessionId = Lockr.get('sessionId')
axiosPhp.defaults.paramsSerializer = function (params) {
  return Qs.stringify(params)
}

let pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken
let removePending = config => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) {
      // 当当前请求在数组中存在时执行函数体
      if (config.method == 'post' || config.method == 'put') {
        pending[p].f('cancel') // 执行取消操作
        pending.splice(p, 1) // 把这条记录从数组中移除
      }
    }
  }
}
// 返回处理
axiosPhp.interceptors.response.use(
  function (response) {
    removePending(response) // 在一个ajax发送前执行一下取消操作
    if (response.data.code == 101) {
      // 清空登录信息
      Lockr.rm('authKey')
      Lockr.rm('sessionId')
      Lockr.rm('userInfo')
      console.log('删除了对象cardTicket.js')
      Lockr.rm('firstRoutePath')
      // // 跳转到登录页
      // router.push({path: '/login'})
      return response
    } else if (response.data.code > 101 && response.data.code != 200) {
      if (response.data.code == 401) {
        // 跳转到登录页
        router.push({path: '/login'})
      }
      return response
    } else {
      return response
    }
  },
  function (error) {
    return Promise.reject(error)
  }
)
// 互动菜单：
// 卡券模板列表
export function cardList (data) {
  let url = API_HOST_JAVA + 'ticket/template/page'
  return axiosPhp.post(url, data)
}
//获取受众列表
export function getModelList () {
  let url = API_HOST_JAVA + 'ticket/template/getModelList'
  return axiosPhp.get(url)
}
// 获取群组列表
export function getModelGroupList (data) {
  let url = API_HOST_JAVA + 'ticket/template/getModelGroupList'
  return axiosPhp.get(url, {
    // params: data
    params: {
      modelId: data.modelId,
      'groupIds[]': data.groupId
    }
  })
}
//卡券模板新增
export function sbmitTemplate (data) {
  let url = API_HOST_JAVA + 'ticket/template'
  return axiosPhp.post(url, data)
}
// 获取产品列表
export function getProductList (data) {
  let url = API_HOST + 'market-api/product/list'
  return axiosPhp.get(url, {
    params: data
  })
}
//卡券模板编辑
export function editTemplate (data) {
  let url = API_HOST_JAVA + 'ticket/template'
  return axiosPhp.put(url, data)
}
//卡券模板列表的启用 禁用 删除
export function delTemplate (data) {
  let url = API_HOST_JAVA + 'ticket/template/state'
  return axiosPhp.put(url, data)
}
// 卡券发放明细列表
export function grantInfoPage (data) {
  console.log(data)
  let url = API_HOST_JAVA + 'ticket/rc/grantInfoPage'
  return axiosPhp.get(url, {
    params: {
      code: data.code,
      templateName: data.templateName,
      grantSystemCode: data.grantSystemCode,
      holder: data.holder,
      receiveTimeStart: data.receiveTimeStart,
      receiveTimeEnd: data.receiveTimeEnd,
      queryState: data.queryState,
      ticketType: data.ticketType,
      'pm.page': data.page,
      'pm.limit': data.limit,
      'pm.sortCode': data.sortCode,
      'pm..sortRole': data.sortRole
    }
  })
}
// 卡券发放明细列表
export function grantSystemList (data) {
  let url = API_HOST_JAVA + 'ticket/system/list'
  return axiosPhp.get(url, {
    params: data
  })
}
// 卡券发放明细导出
export function grantInfoExport (data) {
  let url = API_HOST_JAVA + 'ticket/rc/grantInfoExport'
  return axiosPhp.get(url, {
    params: data,
    responseType: 'blob'
  })
}
// 卡券发放明细核销功能
export function verifiedSubmit (data) {
  let url = API_HOST_JAVA + 'ticket/verified/submit'
  return axiosPhp.put(url, data)
}
// 卡券核销明细列表
export function verifiedList (data) {
  let url = API_HOST_JAVA + 'ticket/verified/pageList'
  return axiosPhp.get(url, {
    params: {
      code: data.code,
      templateName: data.templateName,
      grantSystemCode: data.grantSystemCode,
      holder: data.holder,
      verifiedStartTime: data.verifiedStartTime,
      verifiedEndTime: data.verifiedEndTime,
      ticketType: data.ticketType,
      'pm.page': data.page,
      'pm.limit': data.limit,
      'pm.sortCode': data.sortCode,
      'pm..sortRole': data.sortRole
    }
  })
}
// 卡券发放明细导出
export function verifiedExports (data) {
  let url = API_HOST_JAVA + 'ticket/verified/export'
  return axiosPhp.get(url, {
    params: data,
    responseType: 'blob'
  })
}
// 卡券管理的核销设置
// 获取核销属性
export function findProperty (data) {
  let url = API_HOST_JAVA + 'ticket/verified/findProperty'
  return axiosPhp.get(url, {
    params: data
  })
}
// 添加/修改核销属性
export function propertySet (data) {
  let url = API_HOST_JAVA + 'ticket/verified/propertySet'
  return axiosPhp.post(url, data)
}
